import { render, staticRenderFns } from "./user-report-title.vue?vue&type=template&id=58d78d78"
import script from "./user-report-title.vue?vue&type=script&lang=js"
export * from "./user-report-title.vue?vue&type=script&lang=js"
import style0 from "./user-report-title.vue?vue&type=style&index=0&id=58d78d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports